export interface IAddintegrationItem {
  credentials: {
    login: string;
    password: string;
  };
  key: string;
  request_type: string;
}
